// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__Ssgir","containerItemsCenter":"Skeleton_containerItemsCenter__2pM3M"};